import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useUnmuteConversation = () => {
  const { unmuteConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: IDObject) => conversation.unmute(payload.id),
    onSuccess: (conversation, payload) => {
      unmuteConversation(payload.id);
    },
  });

  return mutation;
};
